import { connect } from 'react-redux'

import coordinators from '@coordinators'
import services from '@services'
import presenters from '@presenters'
import { HandleError } from '@coordinators/composed'

import { CreateMarketplaceUserModal } from '@components/marketplaceUsers'

interface State {
  user: {
    lastLoggedInHq: number
  }
}
const mapStateToProps = (state: State) => {
  const {
    user: { lastLoggedInHq },
  } = state

  return {
    currentHq: lastLoggedInHq,
  }
}

const mapDispatchToProps = () => {
  const { RestService } = services
  const { CreateMarketplaceUser, GetContact } = coordinators
  const { pResponseGeneric } = presenters.Api

  const createMarketplaceUser = CreateMarketplaceUser({
    RestService,
    pResponseMarketplaceUser: pResponseGeneric,
    HandleError,
  })

  const getContact = GetContact({
    RestService,
    pResponseContact: pResponseGeneric,
  })

  return {
    createMarketplaceUser,
    getContact,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateMarketplaceUserModal)
